<div class="h-100">
  <rappider-monaco-code-editor [(ngModel)]="value"
                               [options]="editorOptions"
                               [borderSettings]="{border: 'none'}"
                               [toolbarButtons]="toolbarButtons"
                               [showToolbar]="true"
                               (toolbarButtonClicked)="onToolbarButtonClick($event)"></rappider-monaco-code-editor>
</div>
